export default {
	// inject:['marsMap','marsMeasure'],
	props: ["modelCutPosition"],
	data() {
		return {
			modelCutPosition_show: true,
			modelCutPositionValue: 1,
			translation:this.modelCutPosition||{
				X:0,
				Y:0,
				Z:0,
			}
		}
	},
	methods: {
		adjustPosition(){
			this.$emit('changePosition',this.translation);
		},
		modelCutPositionBox_close() {
			//this.modelCutPosition_show=false;
			this.$emit('modelCutPositionBox_close');
		},
	},
	mounted() {
		
	},
	watch: {

	},
	destroyed() {
		
	},
}
